import React from "react";

// A small, reusable collapsible JSON view. Used for every raw-document reveal
// in the demo (evidence schemas, the mandate template + params, and the sealed
// receipt) so those views stay visually consistent and collapsed by default,
// keeping the page from being overwhelming.
export function CollapsibleJson({
  title,
  subtitle,
  json,
  defaultOpen = false
}: {
  title: string;
  subtitle?: string;
  // A pre-serialized string, or any JSON value (pretty-printed here).
  json: unknown;
  defaultOpen?: boolean;
}) {
  const text = typeof json === "string" ? json : JSON.stringify(json, null, 2);
  return (
    <details className="json-view" open={defaultOpen}>
      <summary className="json-view-summary">
        <span className="json-view-caret" aria-hidden="true" />
        <span className="json-view-title">{title}</span>
        {subtitle && <span className="json-view-sub">{subtitle}</span>}
      </summary>
      <div className="json-view-body">
        <pre className="json-view-pre">{text}</pre>
      </div>
    </details>
  );
}
